import { Box, Card, CardContent, CardMedia, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
import { useSelector } from "react-redux";
import { CardHeader, CardLarge } from '../../app/AppStyles';
import { GetDate, GetTime } from '../../app/AppUtils';

export default function NewsArticleCard() {
    const { article } = useSelector((state) => state.news);

    return (
        <Card key={article.id} sx={{ ...CardLarge }}>
            {article?.image && <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#f5f5f5",
                    borderRadius: 2,
                    width: "100%",
                    height: 250,
                    overflow: "hidden",
                }}
            >
                <CardMedia
                    component="img"
                    image={article?.image}
                    alt="article image"
                    sx={{
                        objectFit: "none",
                        width: "auto",
                        height: "auto",
                        maxWidth: "100%",
                        maxHeight: "100%",
                    }}
                />
            </Box>}
            <CardContent>
                <Typography variant="h6" sx={{ ...CardHeader }}>
                    {article?.title}
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                    {GetDate(article?.date)} ({GetTime(article?.date)}) |{" "}
                    {article?.author}
                </Typography>
                <Typography
                    variant="body1"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(article?.text),
                    }}
                ></Typography>
            </CardContent>
        </Card>
    );
}
